import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { map, Observable } from 'rxjs';

import { API_URL } from '@constants';
import { AnyResource } from '@models';
import { getResourceTypeUrl } from '@shared/utils';

import {
  AiChatResponse,
  AiOneShotResponse,
} from '@shared/components/ai-assistant/ai-assistant.types';

const FORM_HEADERS = { 'Content-Type': 'application/x-www-form-urlencoded' };

@Service()
export class AiAssistantService {
  http = inject(HttpClient);

  chat = (
    resource: AnyResource,
    rids: number[],
    question: string,
    interactionId?: string
  ): Observable<AiChatResponse> => {
    const params = new URLSearchParams();

    rids.forEach((rid) => params.append('rid', String(rid)));
    params.append('question', question);

    if (interactionId) {
      params.append('interactionId', interactionId);
    }

    const url = `${API_URL}/${getResourceTypeUrl(resource.type)}/ai/chat`;

    return this.http
      .post<AiChatResponse>(url, params.toString(), {
        headers: FORM_HEADERS,
        observe: 'response',
      })
      .pipe(
        map((response) => ({
          ...(response.body ?? {}),
          interactionId:
            response.headers.get('x-interaction-id') ?? interactionId ?? null,
        }))
      );
  };

  summarize = (
    resource: AnyResource,
    rids: number[]
  ): Observable<AiOneShotResponse> => {
    const params = new URLSearchParams();

    rids.forEach((rid) => params.append('rid', String(rid)));

    const url = `${API_URL}/${getResourceTypeUrl(resource.type)}/ai/summarize`;

    return this.http.post<AiOneShotResponse>(url, params.toString(), {
      headers: FORM_HEADERS,
    });
  };

  translate = (
    fileRid: number,
    language: string
  ): Observable<AiOneShotResponse> => {
    const params = new URLSearchParams();

    params.append('language', language);

    return this.http.post<AiOneShotResponse>(
      `${API_URL}/files/${fileRid}/ai/translate`,
      params.toString(),
      { headers: FORM_HEADERS }
    );
  };
}
